import React from 'react'
import Error from '../Error/Error';
import styles from './SubmitButton.module.scss';

export default function SubmitButton({ formik, text }) {
    return (
        <>
            {Object.keys(formik.errors).length > 0 && (
                <Error touched={true} error="Please check the form, some required fields are empty." />
            )}
            <div className={styles.container}>
                <button type="submit" className={`meatex-button meatex-button--orange ${styles.button}`}>
                    {text}
                </button>
            </div>
        </>
    )
}
